import { io } from "socket.io-client";
import { URL, vm } from "./config.js";
import { setSocket, setBlId, blId } from "./config.js";
import { showTopNotification } from "../ui/notification.js";

let socket = null;

const RECONNECT_DELAY_MS = 3000;
const MAX_RECONNECT_ATTEMPTS = 10; // ~30s of retrying before giving up
const GIVE_UP_REDIRECT_URL = window.location.origin;

const clearTopNotification = () => {
    document.getElementById("top-notification")?.remove();
};

export const connectToSocket = async (projectId) => {
    if (socket) return socket;

    console.log("Connecting to socket...");
    setBlId(projectId);

    socket = io(URL, {
        reconnection: true,
        reconnectionDelay: RECONNECT_DELAY_MS,
        reconnectionDelayMax: RECONNECT_DELAY_MS,
        reconnectionAttempts: MAX_RECONNECT_ATTEMPTS,
    });
    window.socket = socket;
    setSocket(socket);

    socket.on("disconnect", (reason) => {
        console.trace("Disconnected from socket:", reason);
        // A disconnect we asked for ourselves (e.g. leaving the room)
        // doesn't need to alarm anyone or trigger a reconnect
        if (reason === "io client disconnect") return;

        showTopNotification(
            "Se ha perdido la conexión. Intentando reconectar...",
        );
    });

    // Reconnection itself (retrying, giving up) is handled by the
    // underlying Manager, not the socket — these events only exist there
    socket.io.on("reconnect_attempt", (attempt) => {
        showTopNotification(
            `Intentando reconectar (${attempt}/${MAX_RECONNECT_ATTEMPTS})...`,
        );
    });

    socket.io.on("reconnect", () => {
        clearTopNotification();
        showTopNotification("Conexión restablecida");
        setTimeout(clearTopNotification, 3000);
    });

    socket.io.on("reconnect_failed", () => {
        showTopNotification(
            "No se ha podido reconectar. Volviendo a la página principal...",
        );
        setTimeout(() => {
            window.location.href = GIVE_UP_REDIRECT_URL;
        }, 3000);
    });

    return socket;
};

export const getSocket = () => socket;
